import React, { useState } from "react";
import { HiPencil, HiRefresh } from "react-icons/hi";
import { useDrawer } from "../../context/drawer";
import axios from "axios";
import EmptyComp from "../Empty/EmptyComp";
import { Tooltip } from "antd";
import { BsTrashFill } from "react-icons/bs";
import { useCategoryDetailMutation } from "../../services/userAuthAPI";
import { useSelector } from "react-redux";
import {
  Button,
  List,
  Pagination,
  Popconfirm,
  Select,
  message,
} from "antd";
import Search from "antd/es/input/Search";

import broken_image from "../../images/demo-broken.png";

export default function CardList({
  loading,
  totalData,
  limitComp,
  pageComp,
  setLimitComp,
  setPageComp,
  fetchData,
  fetchList,
}) {
  const { drawerData, setDrawerData } = useDrawer();
  const [branchLoading, setBranchLoading] = useState(false);
  const [branchList, setBranchList] = useState([]);
  const handleChange = (page, pageSize) => {
    setPageComp(page);
    setLimitComp(pageSize);
  };
  const [categoryDetail] = useCategoryDetailMutation();
  const { token } = useSelector((state) => state.auth);

  const handleSubmit = (value, event) => {
    fetchData(pageComp, limitComp, value, "");
  };

  // ======================= Handle Drawer Update =================================

  const handleDrawerUpdate = (value) => {
    setDrawerData({
      ...drawerData,
      isOpen: true,
      type: "clientUpdate",
      title: "Update Data",
      value: value,
    });
  };

  // ========================= Remove Category =====================

  const removeCategory = async (id) => {
    try {
      const formData = new FormData();
      formData.append("category_Id", id); // Corrected field name
      formData.append("action", "remove");
      formData.append("admin_token", "OdRLLsX46k3L8EwZgpNlVK5tKiRaghecPNH");
      const response = await categoryDetail(formData);

      if (response.data) {
        message.success("Category removed successfully!");
        fetchData(pageComp, limitComp); // Refresh data after deletion
      }
    } catch (error) {
      message.error("Failed to remove category!");
      // Handle errors
      console.error("Error making POST request", error);
    }
  };

  return (
    <div>
      <div className="headerTitle d-lg-flex justify-content-between">
        <div className="d-sm-flex justify-content-lg-start justify-content-between">
          <Search
            style={{ marginBottom: "30px", width: "100%", minWidth: "250px", maxWidth: "350px" }}
            placeholder="Search"
            loading={loading}
            enterButton
            onSearch={handleSubmit}
          />
        </div>

        <Button
          type="primary"
          loading={loading}
          icon={<HiRefresh />}
          style={{ marginBottom: "30px" }}
          onClick={() => fetchData(pageComp, limitComp, "", "")}
        >
          Refresh Data
        </Button>
      </div>

      <div className="cardList">
        <div className="row">
          {fetchList && fetchList.length > 0 ? (
            fetchList.map((value, i) => (
              <div className="col-lg-3 col-md-4 col-sm-6 mb-4" key={i}>
                <div className="CardListData">
                  <List>
                    {/* <div className="row">
                      <div className="col-6"> */}


                    <div className="category-card-main-con-image">
                      <img
                        src={value.category_img}
                        alt={value.category_name}
                        style={{ width: "130px", height: "100px", borderRadius: "25px" }}
                        onError={(e) => { e.target.onerror = null; e.target.src = broken_image; }}
                      />
                    </div>
                    <List.Item key={value.category_slugs}>
                      <List.Item.Meta
                        title={value.category_name}
                        description={value.category_desc}
                      >
                      </List.Item.Meta>
                    </List.Item>


                    {/* </div>
                      <div className="col-6">
                    <img
                      src={value.category_img}
                      alt={value.category_name}
                      style={{ width: "130px", height: "100px", borderRadius: "25px" }}
                    />
                    </div>
                    </div> */}
                  </List>
                  <div className="buttonGroup mx-2 mb-2">
                    <Tooltip placement="bottom" title="Edit">
                      <Button
                        onClick={() => handleDrawerUpdate(value)}
                        type="primary"
                        shape="circle"
                      >
                        <HiPencil />
                      </Button>
                    </Tooltip>
                    &nbsp;&nbsp;&nbsp;
                    <Popconfirm
                      title="Remove Category"
                      description="Are you sure you want to remove this category?"
                      onConfirm={() => removeCategory(value.category_Id)}
                      okText="Yes"
                      cancelText="No"
                    >
                      <Tooltip placement="bottom" title="Remove">
                        <Button type="primary" shape="circle">
                          <BsTrashFill />
                        </Button>
                      </Tooltip>
                    </Popconfirm>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <EmptyComp />
          )}
        </div>
      </div>
      <Pagination
        style={{ marginTop: "30px" }}
        total={totalData}
        showTotal={(total, range) => `${range[0]}-${range[1]} of ${total} items`}
        pageSize={limitComp}
        current={pageComp}
        onChange={handleChange}
      />
    </div>
  );
}
